import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../../../auth';
import { Globals } from '../../../globals';
import { Observable } from 'rxjs';

@Injectable()
export class DepartmentTreeService {

    warning: (message?: string) => Promise<boolean>;

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    /**
     *
     */
    public getRootNode(showPeople: boolean, showProjects: boolean) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/department/?showPeople=' + showPeople + '&showProjects=' + showProjects;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'});
    }

    public getNodeChildren(showPeople: boolean, showProjects: boolean, id: string) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/department/' + id + '/children?showPeople=' + showPeople + '&showProjects=' + showProjects;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'});
      }
}
